module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_20.5ce0a42f.png";